import ISampleComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleComponent';
import Switch from '@material-ui/core/Switch';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, Row } from 'antd';
import React from 'react';

import ProcessContext from '../ProcessContext';

interface ISampleSettingsComponentStateType {
  execAllOnStart: boolean;
  execAllOnEnd: boolean;
}

export default class SampleSettingsComponent extends React.Component<any, ISampleSettingsComponentStateType> {

  constructor(props: ISampleComponent) {
    super(props);
    this.state = {
      execAllOnStart: this.props.execAllOnStart || false,
      execAllOnEnd: this.props.execAllOnEnd || false
    };
  }
  //#region HANDLERS

  handleExecStartChange = async (evt: any) => {
    this.setState({ execAllOnStart: evt.target.checked });
  }

  handleExecEndChange = async (evt: any) => {
    this.setState({ execAllOnEnd: evt.target.checked });
  }

  onSave(updateFormflowWithComponent: (component: any) => void) {
    const newComponent = {
      execAllOnStart: this.state.execAllOnStart,
      execAllOnEnd: this.state.execAllOnEnd,
    }
    updateFormflowWithComponent(newComponent);
  }

  //#endregion

  render() {
    return (
      <>
        <CardConfig >
          <Row>
            <Col sm={20} md={20} xl={20} >
              {I18n.l('formflow.components.sampleComponent.execAllonStart')}
            </Col>
            <Col sm={4} md={4} xl={4} >
              <Switch
                color="primary"
                onChange={this.handleExecStartChange}
                checked={this.state.execAllOnStart}
              />
            </Col>
          </Row>
        </CardConfig>
        <DividerBorder />
        <CardConfig >
          <Row>
            <Col sm={20} md={20} xl={20} >
              {I18n.l('formflow.components.sampleComponent.execAllonEnd')}
            </Col>
            <Col sm={4} md={4} xl={4} >
              <Switch
                color="primary"
                onChange={this.handleExecEndChange}
                checked={this.state.execAllOnEnd}
              />
            </Col>
          </Row>
        </CardConfig>
        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>
      </>
    );
  }
}

//#region CSS
const CardConfig = styled.div`
padding-bottom: 25px;
height:auto;
background-color: #F6FCFD;
`;

const DividerBorder = styled.div`
    border-bottom: 1px solid  ${Theme.secondary.lightGrey};
    width: 120%;
    margin-left: -29px;
`;
//#endregion
